module.exports = __webpack_public_path__ + "static/media/marketing-icon.c72b09c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/marketing-icon.svg
// module id = 1916
// module chunks = 0